import instance from "@/services/api";

export const supplierRequestsAPI = {
  async getList(params) {
    return await instance().get('/supplier/read/', { params }).then(res => res?.data);
  },

  async getItems(providerRequestId) {
    return await instance().get(`/supplier/${providerRequestId}/items/`).then(res => res?.data);
  },

  async getStatuses() {
    return await instance().get('/supplier/statuses/').then(res => res?.data);
  },

  async getPurchaseTypes() {
    return await instance().get('/supplier/purchase-types/').then(res => res?.data);
  },

  async getInitiatorTypes() {
    return await instance().get('/supplier/initiator-types/').then(res => res?.data);
  },

  async getProjectsGrouped() {
    return await instance().get('/supplier/projects-grouped/').then(res => res?.data);
  },

  async getMaterials(search = '', limit = 50) {
    return await instance().get('/supplier/materials/', { params: { search, limit } }).then(res => res?.data);
  },

  async getMaterialsPoddon() {
    return await instance().get('/supplier/materials-poddon/').then(res => res?.data);
  },

  async addRequestItem(providerRequestId, payload) {
    return await instance().post(`/supplier/${providerRequestId}/items/add/`, payload).then(res => res?.data);
  },

  async deleteProviderRequestItem(providerRequestItemId) {
    return await instance()
      .delete('/project/provider_requests/delete/', { params: { provider_request_item_id: providerRequestItemId } })
      .then(res => res?.data);
  },

  // Накладные
  async getInvoices(providerRequestId) {
    return await instance().get(`/supplier/${providerRequestId}/invoices/`).then(res => res?.data);
  },

  async getInvoice(providerRequestInvoiceId) {
    return await instance().get(`/supplier/invoice/${providerRequestInvoiceId}/`).then(res => res?.data);
  },

  async getInvoiceItems(providerRequestInvoiceId) {
    return await instance().get(`/supplier/invoice/${providerRequestInvoiceId}/items/`).then(res => res?.data);
  },

  async downloadInvoice(providerRequestInvoiceId) {
    const response = await instance().get(`/supplier/invoice/${providerRequestInvoiceId}/download/`, {
      responseType: 'blob'
    });
    return response;
  },

  async downloadInvoiceScan(providerRequestInvoiceId) {
    const response = await instance().get(`/supplier/invoice/${providerRequestInvoiceId}/download-scan/`, {
      responseType: 'blob'
    });
    return response;
  },

  async getItemsForInvoice(providerRequestId) {
    return await instance().get(`/supplier/${providerRequestId}/items-for-invoice/`).then(res => res?.data);
  },

  async checkInvoiceNum(invoiceNum, providerId) {
    return await instance().get('/supplier/invoice/check-num/', {
      params: { invoice_num: invoiceNum, provider_id: providerId }
    }).then(res => res?.data);
  },

  async createInvoice(data) {
    return await instance().post('/supplier/invoice/create/', data).then(res => res?.data);
  },
  async uploadSignedInvoice(data) {
    return await instance().post('/supplier/invoice/upload-signed-invoice/', data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    ).then(res => res?.data);
  },

  async changeItemStatus(providerRequestItemId, newStatusId) {
    return await instance().post(`/supplier/item/${providerRequestItemId}/change-status/`, { new_status_id: newStatusId }).then(res => res?.data);
  },

  async signInvoice(providerRequestInvoiceId) {
    return await instance().post(`/supplier/invoice/${providerRequestInvoiceId}/sign/`).then(res => res?.data);
  },

  async deleteInvoice(providerRequestInvoiceId) {
    return await instance().delete(`/provider_request/supplier/${providerRequestInvoiceId}/invoice/delete/`).then(res => res?.data);
  },

  async updateInvoice(providerRequestInvoiceId, data) {
    return await instance().put(`/provider_request/supplier/${providerRequestInvoiceId}/invoice/update/`, data).then(res => res?.data);
  },

  async deleteInvoiceItem(providerRequestInvoiceItemId) {
    return await instance().delete(`/provider_request/supplier/${providerRequestInvoiceItemId}/invoice-item/delete/`).then(res => res?.data);
  },

  async updateInvoiceItemQty(providerRequestInvoiceItemId, materialCnt, materialPrice) {
    const body = { material_cnt: materialCnt };
    if (materialPrice !== undefined && materialPrice !== null) {
      body.material_price = materialPrice;
    }
    return await instance().put(`/provider_request/supplier/${providerRequestInvoiceItemId}/invoice-item/update-qty/`, body).then(res => res?.data);
  },

  async addInvoiceItem(providerRequestInvoiceId, providerRequestItemId, materialCnt, materialPrice) {
    return await instance().post(`/provider_request/supplier/${providerRequestInvoiceId}/invoice/add-item/`, {
      provider_request_item_id: providerRequestItemId,
      material_cnt: materialCnt,
      material_price: materialPrice,
    }).then(res => res?.data);
  },

  async getAvailableItemsForInvoice(providerRequestInvoiceId) {
    return await instance().get(`/provider_request/supplier/${providerRequestInvoiceId}/invoice/available-items/`).then(res => res?.data);
  },

  // Реализации
  async getRealizes(providerRequestId) {
    return await instance().get(`/supplier/${providerRequestId}/realizes/`).then(res => res?.data);
  },

  async getRealize(realizeId) {
    return await instance().get(`/supplier/realize/${realizeId}/`).then(res => res?.data);
  },

  async getRealizeItems(realizeId) {
    return await instance().get(`/supplier/realize/${realizeId}/items/`).then(res => res?.data);
  },

  async downloadRealize(realizeId) {
    const response = await instance().get(`/project/realizes/${realizeId}/download/`, {
      responseType: 'blob'
    });
    return response;
  },

  // Материал поставщика (material_provider_tab)
  async updateMaterialProvider(data) {
    return await instance().post('/supplier/material-provider/update/', data).then(res => res?.data);
  },

  async getSbsProjects(search = '', page = 1, limit = 50) {
    return await instance().get('/project/sbs_project/read_all/', { params: { search, page, limit } }).then(res => res?.data);
  },

  async getRequiredTypes() {
    return await instance().get('/material/required_types/').then(res => res?.data);
  },

  async getInvoiceApprovalCityConfig(cityId) {
    return await instance().get('/supplier/invoice-approval-city-config/', { params: { city_id: cityId } }).then(res => res?.data);
  },

  async updateInvoiceApprovalCityConfig(data) {
    return await instance().post('/supplier/invoice-approval-city-config/', data).then(res => res?.data);
  },

  async getInvoiceApprovalEmployees(search = '') {
    return await instance().get('/supplier/invoice-approval-employees/', { params: { search } }).then(res => res?.data);
  },

  async getInvoiceApprovals(params) {
    return await instance().get('/supplier/invoice-approvals/', { params }).then(res => res?.data);
  },

  async decideInvoiceApproval(approvalId, decision, comment) {
    return await instance().post(`/supplier/invoice-approvals/${approvalId}/decide/`, { decision, comment }).then(res => res?.data);
  },
};

